import React from 'react';
import { connect } from 'react-redux';
import { reduxForm, Field, FieldArray, formValueSelector } from 'redux-form';
import PropTypes from 'prop-types';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import styled from 'styled-components';
import RenderTextField from '../../../utils/renderFields/RenderTextField';
import { shouldMakeCustomDeclaration } from '../../../utils/validator';
import validate from './validate';
import RenderFieldArrayItems from './renderField/RenderFieldArrayItems';
import { Title } from './style';

const ButtonContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-around;
  margin-top: 40px;
`;

const CustomButton = styled(Button)`
  width: 130px;
`;

let RecipientInformationsStep = ({
  handleSubmit,
  displayCustomDeclarationField,
  previousPage
}) => (
  <form onSubmit={handleSubmit}>
    <Title>Informations sur le(s) produit(s) à envoyer</Title>
    <Grid container spacing={2}>
      <Grid item md={6}>
        <Field
          name="externalReference"
          label="Référence de la commande"
          component={RenderTextField}
          fullWidth
          type="text"
        />
      </Grid>
      <Grid item md={6}>
        <Field
          name="type.weight"
          label="Poids total de la commande"
          component={RenderTextField}
          fullWidth
          type="number"
        />
      </Grid>
      {displayCustomDeclarationField ? (
        <>
          <Grid item md={4}>
            <Field
              name="type.height"
              label="Hauteur"
              component={RenderTextField}
              fullWidth
              type="number"
            />
          </Grid>
          <Grid item md={4}>
            <Field
              name="type.width"
              label="Largeur"
              component={RenderTextField}
              fullWidth
              type="number"
            />
          </Grid>
          <Grid item md={4}>
            <Field
              name="type.length"
              label="Longeur"
              component={RenderTextField}
              fullWidth
              type="number"
            />
          </Grid>
        </>
      ) : null}
      <Grid item md={12}>
        <FieldArray
          name="items"
          displayCustomDeclarationField={displayCustomDeclarationField}
          component={RenderFieldArrayItems}
        />
      </Grid>
    </Grid>
    <ButtonContainer>
      <CustomButton variant="contained" color="primary" onClick={previousPage}>
        Précédent
      </CustomButton>
      <CustomButton variant="contained" color="primary" type="submit">
        Suivant
      </CustomButton>
    </ButtonContainer>
  </form>
);

const mapStateToProps = state => {
  const selector = formValueSelector('addCommandForm');
  const countryCode = selector(state, 'recipientAddress.countryCode');
  const postalCode = selector(state, 'recipientAddress.postalCode');
  return {
    productBarcode: state.init.productBarcode,
    isStockHandled: state.init.isStockHandled,
    displayCustomDeclarationField: shouldMakeCustomDeclaration(
      countryCode,
      postalCode
    )
  };
};

RecipientInformationsStep = reduxForm({
  form: 'addCommandForm',
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
  validate
})(RecipientInformationsStep);

RecipientInformationsStep.propTypes = {
  handleSubmit: PropTypes.func,
  displayCustomDeclarationField: PropTypes.bool.isRequired,
  previousPage: PropTypes.func.isRequired
};

export default connect(mapStateToProps)(RecipientInformationsStep);
